import {
  Badge,
  Level,
  LevelGroup,
  LevelItem,
  ScaffoldCard,
  Text,
} from '@inmotionnow/momentum-components-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { type AccountUser } from '@/features/accounts/accountApi'

export interface IMemberCardProps {
  member: AccountUser
  accountId?: number
}

const MemberCard: React.FC<IMemberCardProps> = ({ member, accountId }) => {
  const { t } = useTranslation()
  const isActive = member.is_active
  const userDetailsPath = accountId
    ? `/user/details/${member.id}?accountId=${accountId}`
    : `/user/details/${member.id}`

  return (
    <ScaffoldCard data-testid={`member-card-${member.id}`}>
      {/* Column 1 — user details */}
      <>
        {/* Row 1: name */}
        <Level>
          <LevelGroup position='left'>
            <LevelItem>
              <Text textWeight='bold'>
                <Link to={userDetailsPath}>{member.display_name}</Link>
              </Text>
            </LevelItem>
          </LevelGroup>
        </Level>

        {/* Row 2: title badge + phone */}
        {(member.title || member.phone) && (
          <Level>
            <LevelGroup position='left'>
              {member.title && (
                <LevelItem>
                  <Badge
                    text={member.title}
                    namedColor='tertiary'
                    icon='briefcase'
                  />
                </LevelItem>
              )}
              {member.phone && (
                <LevelItem>
                  <Text size='sm' color='muted'>
                    {member.phone}
                  </Text>
                </LevelItem>
              )}
            </LevelGroup>
          </Level>
        )}

        {/* Row 3: active / disabled badge */}
        <Level>
          <LevelGroup position='left'>
            <LevelItem>
              <Badge
                text={isActive ? t('ENABLED') : t('DISABLED')}
                namedColor={isActive ? 'green' : 'red'}
                dataTestingId='member-active-badge'
              />
            </LevelItem>
          </LevelGroup>
        </Level>
      </>

      {/* Column 2 — email + future actions */}
      <Level>
        <LevelGroup position='right'>
          <LevelItem>
            <Text size='sm' color='muted'>
              {member.email}
            </Text>
          </LevelItem>
        </LevelGroup>
      </Level>
    </ScaffoldCard>
  )
}

export { MemberCard }
